/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AssociatedCompanyListItemViewModelPaginatedResponse } from "../types/AssociatedCompanyListItemViewModelPaginatedResponse.ts";
import { associatedCompanyListItemViewModelSchema } from "./associatedCompanyListItemViewModelSchema.ts";

export const associatedCompanyListItemViewModelPaginatedResponseSchema =
  z.object({
    data: z
      .array(z.lazy(() => associatedCompanyListItemViewModelSchema))
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<AssociatedCompanyListItemViewModelPaginatedResponse>;
